import { useRef, useState } from 'react';

import { Link } from 'react-router-dom';

import { motion } from 'framer-motion';

import useGsapSection from '../../hooks/useGsapSection';

import { BlurSplitText, ScrambleReveal, ClipRevealText } from '../TextEffects';

import { WORK_STATS, getPracticeSpanYears } from '../../data/work';

import './ViewAllWorkSection.css';



const ViewAllWorkSection = () => {

  const ref = useRef(null);

  const inView = useGsapSection(ref, { revealY: 32 });

  const [hover, setHover] = useState(false);
  const spanYears = getPracticeSpanYears();



  return (

    <section

      ref={ref}

      id="archive"

      className="vaw"

      data-testid="view-all-section"

    >

      <div className="vaw-strip">

        <span className="vaw-strip-left gsap-reveal">

          <span className="vaw-strip-num">(004)</span>

          <span className="vaw-strip-divider" />

          <ClipRevealText text="Archive" delay={0.05} externalInView={inView} />

          {' '}

          <ScrambleReveal text="— Full Index" delay={0.15} externalInView={inView} />

        </span>

        <span className="vaw-strip-right tabular gsap-reveal">

          <ScrambleReveal

            text={`${String(WORK_STATS.total).padStart(3, '0')} entries`}

            delay={0.2}

            externalInView={inView}

          />

        </span>

      </div>



      <div className="vaw-cta-wrap gsap-reveal">

        <Link

          to="/work"

          className="vaw-cta"

          onMouseEnter={() => setHover(true)}

          onMouseLeave={() => setHover(false)}

          data-testid="view-all-cta"

          aria-label="View all work"

        >

          <span className="vaw-cta-line">

            <BlurSplitText

              text="View all work"

              className="vaw-cta-text"

              delay={0.1}

              stagger={0.08}

              externalInView={inView}

            />

            <motion.span

              className="vaw-cta-arrow"

              animate={hover ? { x: 14, y: -14 } : { x: 0, y: 0 }}

              transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}

              aria-hidden="true"

            >

              ↗

            </motion.span>

          </span>



          <span className="vaw-cta-underline" aria-hidden="true">

            <motion.span

              className="vaw-cta-underline-fill"

              initial={{ scaleX: 0 }}

              animate={hover ? { scaleX: 1 } : { scaleX: 0 }}

              transition={{ duration: 0.7, ease: [0.76, 0, 0.24, 1] }}

              style={{ transformOrigin: hover ? 'left' : 'right' }}

            />

          </span>

        </Link>

      </div>



      <div className="vaw-meta gsap-reveal">

        <div className="vaw-meta-block">

          <ScrambleReveal text="— Total" className="vaw-meta-label" delay={0.1} externalInView={inView} />

          <span className="vaw-meta-value tabular">

            <span className="vaw-meta-big">{String(WORK_STATS.total).padStart(2, '0')}</span>

            <span className="vaw-meta-tail">selected projects</span>

          </span>

        </div>



        <div className="vaw-meta-block">

          <ScrambleReveal text="— Across" className="vaw-meta-label" delay={0.15} externalInView={inView} />

          <span className="vaw-meta-value tabular">

            <span className="vaw-meta-big">{String(WORK_STATS.disciplines).padStart(2, '0')}</span>

            <span className="vaw-meta-tail">disciplines</span>

          </span>

        </div>



        <div className="vaw-meta-block vaw-meta-block-right">

          <ScrambleReveal text="— Span" className="vaw-meta-label" delay={0.2} externalInView={inView} />

          <span className="vaw-meta-value tabular">

            <span className="vaw-meta-big vaw-meta-span tabular">
              <span>{spanYears.start}</span>
              <span className="vaw-meta-span-sep" aria-hidden="true">–</span>
              <span>{spanYears.end}</span>
            </span>

          </span>

        </div>

      </div>

    </section>

  );

};



export default ViewAllWorkSection;

